export default "__VITE_ASSET__Dcm2iSQO__"